import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { loading, failure, RD, SRD } from 'srd';
import { getSecureSubscription } from '../../modules/subscription/service/subscription-service';
import { IRootState } from 'app/shared/reducers';
import { AlertDanger } from 'app/shared/components/alert';

export const onBoard = () => {

  const dispatch = useDispatch()

  const { secureToken, subscriptionNumber } = useParams<{ secureToken: string, subscriptionNumber: string}>();
  const {  errorMessage: errorSubscription } = useSelector((state: IRootState) => state.subscription)
  // const {  issuer } = useSelector((state: IRootState) => state.config)
  const [onBoardSRD, setOnBoardSRD] = React.useState<RD<string, string>>(loading())
  

  // useEffect(() => {
  //   if (issuer) {
  //    window.location.href = issuer+`/login-actions/action-token?key=${secureToken}&subscriptionNumber=${subscriptionNumber}`;
  //   }
  // }, [issuer])

  /* Obsolete */
  useEffect(() => {
    dispatch(getSecureSubscription(secureToken, subscriptionNumber))
  }, [])

  useEffect(() => {
    errorSubscription !== '' &&  setOnBoardSRD(failure(errorSubscription))
  }, [errorSubscription])

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div className="app-loading"><div className="lds-dual-ring" style={{ backgroundColor: 'white', opacity: 0.8, borderRadius: 6 }}></div></div>,
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span><br />{e}</span>}</AlertDanger>,
    success: (d) => <div></div>
  }, onBoardSRD)

  return view
}
